import { Tag } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { Autocomplete } from '../../../../common/components/autocomplete';
import { IAppState, Dispatch } from '../../../../common/state';
import { EBuildingType } from '../../../../json_query';
import { BuildingTypeName } from '../../../../types/commercial';
import { buildingTypeBuildingAdded, buildingTypeBuildingRemoved } from '../../../state/advanced/building_type';
import { InlineParam, Row } from '../markup';

const style = require('./building_type.css');

const allowedTypes: EBuildingType[] = [
  EBuildingType.BusinessCenter,
  EBuildingType.ShoppingEntertainmentCenter,
  EBuildingType.OfficeBuilding,
  EBuildingType.AdministrativeBuilding,
  EBuildingType.PropertyComplex,
  EBuildingType.ManufactureBuilding,
  EBuildingType.ModularBuilding,
  EBuildingType.FreeBuilding,
  EBuildingType.OfficeWarehouse,
  EBuildingType.TradingHouse,
  EBuildingType.TradingOfficeComplex,
];

interface IBuildingPurposeProps {
  buildingTypes: EBuildingType[];
  onBuldingTypeAdded(value: EBuildingType): void;
  onBuldingTypeRemoved(value: EBuildingType): void;
}

const buildingPurpose: React.StatelessComponent<IBuildingPurposeProps> = ({
  buildingTypes,
  onBuldingTypeAdded,
  onBuldingTypeRemoved,
}) => (
  <Row title="Возможное назначение">
    <InlineParam>
      <div className={style['input']}>
        <Autocomplete
          placeholder="Выберите возможное назначение"
          suggestions={Array.from(BuildingTypeName)
            .filter(([key]) => allowedTypes.includes(key) && !buildingTypes.includes(key))
            .map(([key, value]) => ({
              label: value,
              value: key,
            }))}
          onSelect={(suggestion: { label: string; value: EBuildingType }) => onBuldingTypeAdded(suggestion.value)}
        />
      </div>
      {buildingTypes.length > 0 && (
        <div>
          {buildingTypes.map(type => (
            <Tag
              key={`buildingPurpose-${type}`}
              tagStyles={style['tag']}
              onDeleteClick={() => onBuldingTypeRemoved(type)}
            >
              {BuildingTypeName.get(type)}
            </Tag>
          ))}
        </div>
      )}
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    buildingTypes:
      (state.filters.jsonQuery.building_type__building && state.filters.jsonQuery.building_type__building.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onBuldingTypeAdded: (value: EBuildingType) => {
      dispatch(buildingTypeBuildingAdded(value));
    },
    onBuldingTypeRemoved: (value: EBuildingType) => {
      dispatch(buildingTypeBuildingRemoved(value));
    },
  }),
)(buildingPurpose);
